import { toggleRequestButtonLoading } from './actions';
import { DEFAULT_ERROR_MESSAGE } from '../../constants/messages';
import { selectUser } from '../../selectors/user';
import { canUserCreateRequest } from '../../services/newbuildingBroker';
import { TThunkAction } from '../../types/redux/thunk';
import { getCianSource, isNewbuildingBrokerCianSource } from '../../utils/cianSource';
import { createError } from '../../utils/notification';
import { pushNotification } from '../notifications';

export const canUserCreateRequestAction = (): TThunkAction<Promise<boolean>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const state = getState();
    const user = selectUser(state);
    const cianSource = getCianSource();

    if (!user.isAuthenticated || !cianSource || !isNewbuildingBrokerCianSource(cianSource, context.config)) {
      return true;
    }

    dispatch(toggleRequestButtonLoading(true));

    try {
      const response = await canUserCreateRequest({ httpApi });

      return response.canCreate;
    } catch (ex) {
      logger.error(ex, {
        domain: 'actions/newbuildingBroker/canUserCreateRequest',
      });

      dispatch(pushNotification(createError(DEFAULT_ERROR_MESSAGE)));

      throw ex;
    } finally {
      dispatch(toggleRequestButtonLoading(false));
    }
  };
};
